import { SlidersHorizontal } from "lucide-react";
import { Button } from "../ui/button";

export const FiltersButton = ({ isOpen, onClick }) => {
  return (
    <Button
      variant="outline"
      className={`gap-2 ${
        isOpen ? "bg-igbanwo-mint/10 border-igbanwo-mint/20" : ""
      }`}
      onClick={onClick}
    >
      <SlidersHorizontal className="h-4 w-4" />
      Filters
    </Button>
  );
};
